import React, { useState } from 'react';

import { FormikHelpers } from 'formik';

import { Container, Input, SearchIcon, Label } from './styles';
import LoadingFilter from 'components/LoadingFilter';

export interface RenderProps {
  show: boolean;
  value: any;
  onClose: () => void;
  onChange: (value: any) => void;
}

interface Props {
  name?: string;
  value?: any;
  placeHolder?: string;
  icon?: JSX.Element;
  error?: string;
  disabled?: boolean;
  label?: string;
  selectRef?: React.RefObject<HTMLDivElement>;
  children: (renderProps: RenderProps) => JSX.Element;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
  onChildrenChange?: (value: any) => void;
  onSetValue?: (value: any) => string;
  onSetFieldValue?: (value: any) => any;
  formik?: FormikHelpers<string>;
  loading?: boolean;
}

const SearchSelect = ({
  name,
  value,
  placeHolder,
  icon,
  error,
  disabled,
  children,
  onChange,
  onSetValue,
  onSetFieldValue,
  formik,
  selectRef,
  label,
  onChildrenChange,
  loading
}: Props) => {
  const [showOptions, setShowOptions] = useState(false);
  const newValue = value?.name !== (null || undefined) ? value.name : value;

  const handleClick = () => setShowOptions(!showOptions);

  const handleOptionsClose = () => {
    setShowOptions(false);
    if (name && formik) {
      formik.setFieldTouched(name);
    }
  };

  const handleChange = async (newValue: any) => {
    if (name && formik) {
      await formik.setFieldValue(name, onSetFieldValue ? onSetFieldValue(newValue) : newValue);
      formik.setFieldTouched(name);
    } else if (onChildrenChange) {
      onChildrenChange(newValue);
    }
  };

  return (
    <>
      {loading ?
        <LoadingFilter></LoadingFilter> :
        <Container ref={selectRef} onClick={!disabled ? handleClick : () => {}}>
          {label && <Label htmlFor={`custom_select_${name}`}>{label}</Label>}
            <Input
              id={`custom_select_${name}`}
              error={error}
              placeholder={placeHolder}
              onChange={onChange}
              value={onSetValue ? onSetValue(value) : newValue}
            >
              {icon || <SearchIcon />}
            </Input>


          {children({
            show: showOptions,
            value,
            onClose: handleOptionsClose,
            onChange: handleChange,
          })}
        </Container>
      }
    </>
  );
};

export default SearchSelect;
